<template>
  <SvgSprite />
  <div class="as-matches" ref="scrollComponent">
    <div
      v-for="competition in leagues"
      :key="competition.id"
      :class="`as-competition-wrapper as-competition-wrapper-${gSiteName}`"
    >
      <div class="as-league_title">
        <img
          v-if="competition.isShowLogo"
          class="as-lazyload"
          :src="getImgUrlBySport('competition', competition.id)"
          :alt="competition.title"
        />{{ competition.title }}
      </div>

      <MatchItem
        v-for="match in competition.matchs"
        :key="match.id"
        :match="match"
        :competitionType="competition.type"
        @itemClicked="handleItemClicked"
      />
    </div>
  </div>

  <PopupLinkStream
    :isShowPopup="isShowPopupLinkStream"
    :match="matchLinkStream"
    :sites="matchLives?.sites || []"
    @toggle="isShowPopupLinkStream = !isShowPopupLinkStream"
  />
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, reactive, computed } from "vue";
import SvgSprite from "~src/components/matches/SvgSprite.vue";
import MatchItem from "~src/modules/schedule/components/MatchItem.vue";
import type { ICompetitions, IFilterResult, IMatch, IMatchLiveData, IMatchLiveDict } from "~src/interfaces";
import PopupLinkStream from "~src/modules/schedule/components/PopupLinkStream.vue";

const emits = defineEmits(["loadInverse"]);

interface IProps {
  competitions: ICompetitions[];
  filter: IFilterResult;
  isLoadMoreInverse: boolean;
  isLoadInverse: boolean;
  matchLives: IMatchLiveData
}

const props = withDefaults(defineProps<IProps>(), {});
const page = ref(1);
const isLoadMore = ref(false);
const competitionEnd = ref(0);
const scrollComponent = ref<HTMLElement | null>(null);
const leagues = ref<Array<ICompetitions>>([]);

const isShowPopupLinkStream = ref(false);
const matchLinkStream = ref<IMatch | null>(null);

onMounted(() => {
  loadMoreLeagues();
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

const getLeagues = () => {
  const limit = 50;
  const offset = page.value * limit;

  let count = 0;
  let datas: Array<ICompetitions> = [];
  const __matchLives = props.matchLives.matches || []
  props.competitions.forEach((competition: ICompetitions, index: any) => {
    if (
      (competitionEnd.value === 0 || competitionEnd.value < index) &&
      count < offset
    ) {
      competition = updateCompetitionWithMatchLives(competition, __matchLives)
      datas.push(competition);
      if (competitionEnd.value < index) {
        competitionEnd.value = index;
      }
      count += competition.matchs.length;
    }
  });

  return datas;
};

const loadMoreLeagues = () => {
  if (
    isLoadMore.value &&
    props.competitions.length - 1 === competitionEnd.value
  ) {
    return;
  }
  isLoadMore.value = true;
  page.value = page.value + 1;
  let newleagues = getLeagues();
  leagues.value.push(...newleagues);
};

const handleScroll = (e: any) => {
  let element = scrollComponent.value;
  if (
    element &&
    element.getBoundingClientRect().bottom < window.window.innerHeight + 300
  ) {
    loadMoreLeagues();
  }

  // if (!props.isLoadMoreInverse && props.isLoadInverse && props.filter.tag) {
  //   let element = scrollComponent.value;
  //   if (
  //     element &&
  //     element.getBoundingClientRect().bottom <= window.innerHeight + 600
  //   ) {
  //     emits("loadInverse", true);
  //   }
  // }
};

const handleItemClicked = (match: IMatch, flag: boolean) => {
  matchLinkStream.value = match;
  isShowPopupLinkStream.value = flag;
};

const updateCompetitionWithMatchLives = (competition: ICompetitions, matchLives: IMatch[]) => {
    const matchLiveDict = matchLives.reduce<IMatchLiveDict>((acc, match: IMatch) => {
        acc[match.id] = match;
        return acc;
    }, {});

    competition.matchs = competition.matchs.map(match => ({
        ...match,
        match_live_item: matchLiveDict[match.id] || null
    }));

    return competition;
};
</script>

<script lang="ts">
export default {};
</script>

<style scoped></style>
